import { render, staticRenderFns } from "./Encounters.vue?vue&type=template&id=0986a997&scoped=true&"
import script from "./Encounters.vue?vue&type=script&lang=js&"
export * from "./Encounters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0986a997",
  null
  
)

export default component.exports